<section class="flex flex-col overflow-visible" [ngClass]="bgColor()">
    <div
        [ngClass]="[expand() ? 'w-scree overflow-y-scroll' : 'xl:container xl:mx-auto']"
        class="flex flex-col overflow-visible select-none size-full"
    >
        <ng-content />
    </div>
</section>
